"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APIError", {
  enumerable: true,
  get: function get() {
    return _APIError.default;
  }
});
Object.defineProperty(exports, "Cursor", {
  enumerable: true,
  get: function get() {
    return _Cursor.default;
  }
});
Object.defineProperty(exports, "CURSOR_COMPATIBILITY_SYMBOL", {
  enumerable: true,
  get: function get() {
    return _Cursor.CURSOR_COMPATIBILITY_SYMBOL;
  }
});
Object.defineProperty(exports, "EditorialWorkflowError", {
  enumerable: true,
  get: function get() {
    return _EditorialWorkflowError.default;
  }
});
Object.defineProperty(exports, "EDITORIAL_WORKFLOW_ERROR", {
  enumerable: true,
  get: function get() {
    return _EditorialWorkflowError.EDITORIAL_WORKFLOW_ERROR;
  }
});
Object.defineProperty(exports, "localForage", {
  enumerable: true,
  get: function get() {
    return _localForage.default;
  }
});
Object.defineProperty(exports, "isAbsolutePath", {
  enumerable: true,
  get: function get() {
    return _path.isAbsolutePath;
  }
});
Object.defineProperty(exports, "basename", {
  enumerable: true,
  get: function get() {
    return _path.basename;
  }
});
Object.defineProperty(exports, "fileExtensionWithSeparator", {
  enumerable: true,
  get: function get() {
    return _path.fileExtensionWithSeparator;
  }
});
Object.defineProperty(exports, "fileExtension", {
  enumerable: true,
  get: function get() {
    return _path.fileExtension;
  }
});
Object.defineProperty(exports, "filterPromises", {
  enumerable: true,
  get: function get() {
    return _promise.filterPromises;
  }
});
Object.defineProperty(exports, "filterPromisesWith", {
  enumerable: true,
  get: function get() {
    return _promise.filterPromisesWith;
  }
});
Object.defineProperty(exports, "onlySuccessfulPromises", {
  enumerable: true,
  get: function get() {
    return _promise.onlySuccessfulPromises;
  }
});
Object.defineProperty(exports, "resolvePromiseProperties", {
  enumerable: true,
  get: function get() {
    return _promise.resolvePromiseProperties;
  }
});
Object.defineProperty(exports, "flowAsync", {
  enumerable: true,
  get: function get() {
    return _promise.flowAsync;
  }
});
Object.defineProperty(exports, "then", {
  enumerable: true,
  get: function get() {
    return _promise.then;
  }
});
Object.defineProperty(exports, "unsentRequest", {
  enumerable: true,
  get: function get() {
    return _unsentRequest.default;
  }
});
Object.defineProperty(exports, "filterByPropExtension", {
  enumerable: true,
  get: function get() {
    return _backendUtil.filterByPropExtension;
  }
});
Object.defineProperty(exports, "getAllResponses", {
  enumerable: true,
  get: function get() {
    return _backendUtil.getAllResponses;
  }
});
Object.defineProperty(exports, "parseLinkHeader", {
  enumerable: true,
  get: function get() {
    return _backendUtil.parseLinkHeader;
  }
});
Object.defineProperty(exports, "parseResponse", {
  enumerable: true,
  get: function get() {
    return _backendUtil.parseResponse;
  }
});
Object.defineProperty(exports, "responseParser", {
  enumerable: true,
  get: function get() {
    return _backendUtil.responseParser;
  }
});
Object.defineProperty(exports, "getCollectionDepth", {
  enumerable: true,
  get: function get() {
    return _backendUtil.getCollectionDepth;
  }
});
Object.defineProperty(exports, "loadScript", {
  enumerable: true,
  get: function get() {
    return _loadScript.default;
  }
});
Object.defineProperty(exports, "getBlobSHA", {
  enumerable: true,
  get: function get() {
    return _getBlobSHA.default;
  }
});
Object.defineProperty(exports, "asyncLock", {
  enumerable: true,
  get: function get() {
    return _asyncLock.asyncLock;
  }
});
exports.NetlifyCmsLibUtil = void 0;

var _APIError = _interopRequireDefault(require("./APIError"));

var _Cursor = _interopRequireWildcard(require("./Cursor"));

var _EditorialWorkflowError = _interopRequireWildcard(require("./EditorialWorkflowError"));

var _localForage = _interopRequireDefault(require("./localForage"));

var _path = require("./path");

var _promise = require("./promise");

var _unsentRequest = _interopRequireDefault(require("./unsentRequest"));

var _backendUtil = require("./backendUtil");

var _loadScript = _interopRequireDefault(require("./loadScript"));

var _getBlobSHA = _interopRequireDefault(require("./getBlobSHA"));

var _asyncLock = require("./asyncLock");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NetlifyCmsLibUtil = {
  APIError: _APIError.default,
  Cursor: _Cursor.default,
  CURSOR_COMPATIBILITY_SYMBOL: _Cursor.CURSOR_COMPATIBILITY_SYMBOL,
  EditorialWorkflowError: _EditorialWorkflowError.default,
  EDITORIAL_WORKFLOW_ERROR: _EditorialWorkflowError.EDITORIAL_WORKFLOW_ERROR,
  localForage: _localForage.default,
  basename: _path.basename,
  fileExtensionWithSeparator: _path.fileExtensionWithSeparator,
  fileExtension: _path.fileExtension,
  filterPromises: _promise.filterPromises,
  filterPromisesWith: _promise.filterPromisesWith,
  onlySuccessfulPromises: _promise.onlySuccessfulPromises,
  resolvePromiseProperties: _promise.resolvePromiseProperties,
  flowAsync: _promise.flowAsync,
  then: _promise.then,
  unsentRequest: _unsentRequest.default,
  filterByPropExtension: _backendUtil.filterByPropExtension,
  parseLinkHeader: _backendUtil.parseLinkHeader,
  parseResponse: _backendUtil.parseResponse,
  responseParser: _backendUtil.responseParser,
  loadScript: _loadScript.default,
  getBlobSHA: _getBlobSHA.default,
  getCollectionDepth: _backendUtil.getCollectionDepth
};
exports.NetlifyCmsLibUtil = NetlifyCmsLibUtil;